import { Box, Stack, Typography } from "@mui/material";
import { AxiosResponse } from "axios";
import { commonStyle } from "pages/Dashboard/common.styles";
import { useEffect, useState } from "react";
import { PieWeeklyGraphResponse } from "reduxStore/dataTypes";
import { fetchAdminWeeklyRatio } from "services/apiService";
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import theme, { responsiveFontSize } from "themes/Theme";
import CalendarTodayIcon from "assets/svg/CalendarTodayIcon";

const TransactionRatio = () => {
  const [weeklyData, setWeeklyData] = useState<any[] | null>(null);
  const COLORS = ["#0f5051", "#2edadc"];
  const [noDataFound, setNoDataFound] = useState(false);
  const getPieGraphData = async () => {
    try {
      const response: AxiosResponse<PieWeeklyGraphResponse> =
        await fetchAdminWeeklyRatio();
      if (response && response.status === 200) {
        if (
          Number(response?.data?.data?.receiveRatio) === 0 &&
          Number(response?.data?.data?.transferRatio) === 0
        ) {
          setNoDataFound(true);
        } else {
          const data = [
            {
              name: "Receive",
              value: Number(response?.data?.data?.receiveRatio),
            },
            {
              name: "Transfer",
              value: Number(response?.data?.data?.transferRatio),
            },
          ];
          setWeeklyData(data);
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    getPieGraphData();
  }, []);

  const renderLabel = ({ name, value }: { name: string; value: number }) => {
    return `${value}%`;
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography sx={commonStyle.cardTitleText}>
          Transactions - Transfer vs Receive
        </Typography>
        <Stack
          direction={"row"}
          alignItems={"center"}
          sx={styles.calendarBg}
          gap={1}
        >
          <CalendarTodayIcon />
          <Typography sx={styles.calendarText}>This Year</Typography>
        </Stack>
      </Box>
      {noDataFound ? (
        <Typography
          sx={{
            height: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.text.secondary,
            fontSize: responsiveFontSize(16),
          }}
        >
          No Data Available
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={weeklyData || []}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={window.innerWidth < 600 ? 70 : 100}
              label={renderLabel}
            >
              {weeklyData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string) => {
                return [`${value}%`, name];
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};
export default TransactionRatio;
const styles = {
  calendarBg: {
    backgroundColor: "rgba(245, 245, 246, 1)",
    borderRadius: 3,
    boxShadow: `rgba(8, 60, 61, 0.27) 0px 1px 5px 0px, rgba(8, 60, 61, 0.06) 0px 1px 5px 0px`,
    padding: "5px 8px",
    width: "fit-content",
  },
  calendarText: {
    fontSize: responsiveFontSize(12),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  container: {
    borderRadius: 3,
    boxShadow: `rgba(8, 60, 61, 0.27) 0px 1px 5px 0px, rgba(8, 60, 61, 0.06) 0px 1px 5px 0px`,
    backgroundColor: "rgb(255, 255, 255)",
    p: 3,
    width: "100%",
  },
};
